import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import _ from 'lodash';
import DataTable from '../DataTable/table';
import { initColumns } from './Columns/columns';
import { isUncoded, isMatchable, isUnappliedRule, isRahBankOrCredit } from './Columns/columnsHelpers';
import Spinner from '../UI/Spinner/spinner';
// import { useTraceUpdate } from '../Common/useTraceUpdate';

const findRowX = (updatedRows, key) => {
    return updatedRows.findIndex(row => row.BankDataGUID === key);
}

let currentCell = undefined;
let currentRows = [];

const TransactionDataTable = (props) => {
    const { hasGST, isRah, version, isR1, contacts, account, transactionCodes, editableDescription, displayAccount, classification
        , transactionsList, selectTransactions, selectTransaction, deselectTransaction, isRuleFound, handleGST, handleContact
        , handleClassification, handleDescription, handleUndoDescription, handleQuantity, handleAcceptRule, showSplitModalHandler
        , showRuleModalHandler, showCommentModalHandler, sortColumn, sortOrder, handleSelectAccount, hideColumns, matches, taxTracking
        , moveCell, setMoveCell, leaveRow, selectCell, matchLoadingList, searchText, filterBy, uncodedOnly, copyCoding, updateTransactionsStat
        , apiError, dateRange, bookId, getTransactions, sortRows, handleSorting, activateCell, focusedCell, focusedCellChange
        , codeOpen, showModal, removeMatchList, removeMatchButton, isLoadingTransactions } = props;
    // useTraceUpdate('TransactionDataTable', props);
    const isFirstRun = useRef(true);
    const [columns, setColumns] = useState(null);
    const [rows, _setRows] = useState(undefined);
    const [openSplit, _setOpenSplit] = useState(true);
    const openSplitRef = useRef(openSplit);
    const rowsRef = useRef(rows);
    const codeOpenRef = useRef(codeOpen);
    const showModalRef = useRef(showModal);
    const matchesRef = useRef(matches);
    const removeMatchListRef = useRef(removeMatchList);
    const uncodedSet = uncodedOnly || filterBy === 'Uncoded';
    const setRows = (rows) => {
      if (uncodedSet && rows && rowsRef.current && rowsRef.current.length - rows.length === 1) {
        let rowIndex = -1;
        for (let i = 0; i < rowsRef.current.length; i++) {
          if (rowsRef.current[i] && rows[i] && rowsRef.current[i].BankDataGUID !== rows[i].BankDataGUID) {
            rowIndex = i;
            break;
          }
        }

        if (rowIndex > -1 && focusedCell.x > rowIndex && focusedCell.x > 0) {
          setMoveCell({ moveCell: { x: -1, y: 0, tabStoping: false, uncoded: true } });
          activateCell();
        }
      }
      rowsRef.current = rows;
      _setRows(rows);
    };
    const setShowModal = () => {
      codeOpenRef.current = codeOpen;
      showModalRef.current = showModal;
      _setRows(rows);
    };

    const setSplit = (status) => {
      openSplitRef.current = status;
      _setOpenSplit(status);
    };

    const columnDefaultWidthValues = { batchTickbox: 75, transactionDate: 85, type: 150, traceId: 65, accountCode: 150, gstCode: 100, gstAmount: 85, quantity: 80, moneyIn: 120, moneyOut: 120, contactId: 110, classificationId: 110, statusIcons: 100 };
    let columnWidthValues = localStorage.getItem('columnPxWidths') ? JSON.parse(localStorage.getItem('columnPxWidths')) : columnDefaultWidthValues;
    delete columnWidthValues.description;

    const columnMinWidthValues = { batchTickbox: 75, transactionDate: 65, traceId: 65, type: 65, description: 120, moneyIn: 80, moneyOut: 80, accountCode: 85, gstAmount: 65, gstCode: 85, quantity: 80, contactId: 85, classificationId: 85, statusIcons: 85 };
    const columnMaxWidthValues = { batchTickbox: 120, transactionDate: 300, traceId: 200, type: 400, description: 5000, moneyIn: 400, moneyOut: 400, accountCode: 600, gstAmount: 400, gstCode: 400, quantity: 200, contactId: 400, classificationId: 400, statusIcons: 150 };
    useEffect(
      () => {
        setShowModal();
      },
      [codeOpen, showModal]
    );
    useEffect(() => {
      document.addEventListener('keydown', onKeyDown, false);
      return function cleanup() {
        document.removeEventListener('keydown', onKeyDown, false);
      };
    }, []);

    useEffect(
      () => {
        currentCell = focusedCell;
        setSplit(true);
      },
      [focusedCell]
    );

    //Columns related
    useEffect(
      () => {
        setColumns(
          initColumns(
            hasGST,
            isR1,
            isRah,
            contacts,
            account,
            transactionCodes,
            editableDescription,
            displayAccount,
            classification,
            transactionsList,
            selectTransactions,
            selectTransaction,
            deselectTransaction,
            isRuleFound,
            matchLoadingList,
            handleGST,
            handleContact,
            handleClassification,
            handleDescription,
            handleUndoDescription,
            handleQuantity,
            handleAcceptRule,
            handleRemoveRule,
            showRuleModalHandler,
            showCommentModalHandler,
            sortGrid,
            sortColumn,
            sortOrder,
            activateCell,
            handleSelectAccount,
            hideColumns,
            matches,
            rows,
            taxTracking,
          )
        );
      },
      [
        matches,
        matchLoadingList,
        transactionsList,
        sortColumn,
        sortOrder,
        hideColumns,
        editableDescription,
        displayAccount,
        taxTracking,
        rows
      ]
    );

    //Store matchRef & removeMatchListRef for onKeyDown function
    useEffect(
      () => {
        matchesRef.current = matches;
        removeMatchListRef.current = removeMatchList;
      },
      [matches, removeMatchList]
    );

    //Rows related
    useEffect(
      () => {
        let rowsToSet = transactionsList;
        if (rowsToSet.length > 0) {
          //Search
          if (searchText && searchText.length > 2) {
            const search = searchText.toLowerCase();
            const matchedIds = matches.filter((item) =>
              (item.TransactionNumber && item.TransactionNumber.toLowerCase().includes(search)) ||
              (item.TransactionRef && item.TransactionRef.toLowerCase().includes(search)) ||
              (item.TransactionDate && (item.TransactionDate.includes(search) ||
                moment(item.TransactionDate).format('D MMM').toLowerCase().includes(search))) ||
                moment(item.TransactionDate).format('DD-MM-YYYY').toLowerCase().includes(search) ||
              (item.OtherParty && typeof item.OtherParty === 'string' && item.OtherParty.toLowerCase().includes(search)) ||
              (item.TxnType && item.TxnType.toLowerCase().includes(search)) ||
              (item.AccountDetails && item.AccountDetails.length > 0 && item.AccountDetails.some(account => account.name && account.name.toLowerCase().includes(search)))
            ).map((item) => item.MatchId);

            const accountIds = transactionCodes.chart
              .filter((item) => item.label.toLowerCase().includes(search) || item.value.toLowerCase().includes(search))
              .map((item) => item.value);

            const contactIds = contacts
              .filter((item) => item.label.toLowerCase().includes(search)).map((item) => item.value);

            rowsToSet = rowsToSet.filter((item) => {
              return (
                item.TransactionType && item.TransactionType.toLowerCase().includes(search) ||
                item.TraceID && item.TraceID.toLowerCase().includes(search) ||
                item.Description.toLowerCase().includes(search) ||
                item.TransactionDate.toLowerCase().includes(search) ||
                Math.abs(item.Amount)
                  .toFixed(2)
                  .includes(search) ||
                (item.Coding.length > 0 && accountIds ? item.Coding.find((code) => accountIds.includes(code.AccountCode)) : false) ||
                (item.SuggestedMatches && matchedIds && item.SuggestedMatches.some(matchId => matchedIds.includes(matchId))) ||
                (item.Coding.length > 0 && contactIds.length > 0 ? item.Coding.find((code) => contactIds.includes(code.contactId)) : false)
              );
            });
          }
          //Filter
          if (filterBy) {
            switch (filterBy) {
              case 'Uncoded':
                rowsToSet = rowsToSet.filter((item) => isUncoded(item, isRah) || item.notCoded);
                break;
              case 'Coded':
                rowsToSet = rowsToSet.filter((item) => !isUncoded(item, isRah) || item.notCoded);
                break;
              case 'Unmatched':
                rowsToSet = rowsToSet.filter((item) => isMatchable(item, matches));
                break;
              case 'Matched':
                rowsToSet = rowsToSet.filter((item) => item.MatchId);
                break;
              case 'Unapplied Rules':
                rowsToSet = rowsToSet.filter((item) => isUnappliedRule(item));
                break;
              default:
                rowsToSet = [...rowsToSet];
            }
          }
          if (!isRah && uncodedSet) {
            rowsToSet = rowsToSet.filter((item) => isUncoded(item, isRah) || item.notCoded);
          }
        }
        setRows(rowsToSet);
        currentRows = rowsToSet ? rowsToSet : [];
        const transactionStats = {
          transactions: rowsToSet ? rowsToSet.length : 0,
          uncoded: rowsToSet ? rowsToSet.filter((item) => isUncoded(item, isRah)).length : 0,
        };
        updateTransactionsStat(transactionStats);
      },
      [filterBy, searchText, transactionsList, uncodedSet]
    );

    useEffect(() => {
        setRows(undefined);
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }
        getTransactions(bookId, account, dateRange);
        updateTransactionsStat({});
    }, [account, dateRange])

    const isMatchButton = (row, matches, removeMatchList) => isMatchable(row, matches) && !removeMatchList.includes(row.BankDataGUID);

    const disabledCellChecker = (row, columnId) => {
        if (!row) return;
        const accountCode = transactionCodes.chart.find(x => x.value === row.AccountCode);
        const isMatch = row.MatchId;
        return (columnId === 'gstCode' && (isRahBankOrCredit(accountCode) || row.Coding.length !== 1 || (isRah && isUnappliedRule(row)))) || (columnId === 'contactId' && (isRahBankOrCredit(accountCode) || row.Coding.length !== 1 || (isRah && isUnappliedRule(row)))) || (columnId === 'classificationId' && (isRahBankOrCredit(accountCode) || row.Coding.length !== 1 || (isRah && isUnappliedRule(row)))) || (columnId === 'description' && (!editableDescription || isRuleFound(row))) || (columnId === 'quantity' && (row.Coding.length > 1 || (isRah && (isUnappliedRule(row) || isMatch || isMatchButton(row, matches, removeMatchList))))) || (row.AccountCode && row.AccountCode === '-1') || row.IsTransferFlagged || row.TransferDate || row.Reconciled || row.isTransactionLocked || (row.isSaving && !isRah) || row.locked;
    }
    const saveColumnWidth = (columnWidths) => {
        localStorage.setItem('columnPxWidths', JSON.stringify(columnWidths));
        columnWidthValues = columnWidths;
    }

    const onKeyDown = (e) => {
        const updatedRows = rowsRef.current;
        const updatedCodeOpen = codeOpenRef.current;
        const updatedShowModal = showModalRef.current;
        const currentMatches = matchesRef.current;
        const openSplit = openSplitRef.current;
        const currentRemoveMatchList = removeMatchListRef.current;
        if (updatedCodeOpen || updatedShowModal) return;
        const currentTransaction = currentRows.find((row) => row.BankDataGUID === currentCell.key);
        const ruleFound = isRuleFound(currentTransaction);
        const matchFound = isMatchButton(currentTransaction, currentMatches, currentRemoveMatchList);
        const moveByKeysArray = [33, 34, 35, 36, 37, 38, 39, 40];

        if (moveByKeysArray.includes(e.keyCode) && !currentCell.active) {
          onMoveByKey(e);
        } else if (e.key === 'Escape' && currentCell.active && currentCell.column.tabStop) {
          setMoveCell({ moveCell: { x: 0, y: 0, tabStoping: false } });
          setSplit(true);
        } else if (e.key === 'Backspace' || e.key === 'Delete') {
          if (matchFound) removeMatchButton(currentTransaction.BankDataGUID);
          else if (ruleFound) handleRemoveRule(currentTransaction);
        } else if (e.key === 'Tab') {
          const y = e.shiftKey ? -1 : 1;
          setMoveCell({ moveCell: { x: 0, y, version: Math.random(), tabStoping: true } });
        } else if (e.key === 'Enter' && currentCell) {
          if (!currentCell.active && currentCell.column && currentCell.column.tabStop) {
            activateCell();
          } else if (updatedRows && currentCell.x + 1 === updatedRows.length) {
            leaveRow(currentCell);
          } else {
            if (currentCell.column && currentCell.column.id === 'accountCode' && currentCell.active) {
              if (matchFound) {
                const firstSuggestedMatch = { isMatch: true, value: currentTransaction.SuggestedMatches[0] };
                handleSelectAccount(firstSuggestedMatch, currentTransaction, true);
              } else if (ruleFound) {
                handleAcceptRule(currentTransaction);
              }
            }
            setMoveCell({
              moveCell: { x: 1, y: -currentCell.y, version: Math.random(), tabStoping: true, stopAtColId: 'accountCode' },
            }); //todo must uncomment
          }
        } else if (!isR1 && e.ctrlKey && e.key === 'm' && currentCell.key) {
          // Open Rule Modal with details of current transactions
          showRuleModalHandler(currentTransaction);
        } else if (e.key === '/' && currentTransaction && openSplitRef.current) {
          // Open Split Modal
          //   ReactGA.event({ category: 'User', action: 'Openned split screen' });
          currentTransaction.Coding = currentTransaction.Coding.map((item) => {
            if (typeof item.Amount === 'number') item.Amount = item.Amount.toFixed(2);
            return item;
          });
          if (openSplit) showSplitModalHandler(currentTransaction);
        } else if (e.key === '+' && currentCell.x > 0) {
          const currentTransaction = updatedRows.find((row) => row.BankDataGUID === currentCell.key);
          const sourceCoding = updatedRows[currentCell.x - 1];
          copyCoding(currentTransaction, sourceCoding);
        } else {
          setSplit(false);
        }
    }

    const onMoveByKey = (e) => {
        if (e.key === 'ArrowRight') {
            setMoveCell({ moveCell: { x: 0, y: 1, tabStoping: false } });
        }

        if (e.key === 'ArrowLeft') {
            setMoveCell({ moveCell: { x: 0, y: -1, tabStoping: false } });
        }

        if (e.key === 'ArrowUp') {
            setMoveCell({ moveCell: { x: -1, y: 0, tabStoping: false } });
        }

        if (e.key === 'ArrowDown') {
            setMoveCell({ moveCell: { x: 1, y: 0, tabStoping: false } });
        }

        if (e.key === 'PageDown') {
            setMoveCell({ moveCell: { x: 10, y: 0, tabStoping: false } });
        }

        if (e.key === 'PageUp') {
            setMoveCell({ moveCell: { x: -10, y: 0, tabStoping: false } });
        }

        if (e.key === 'Home') {
            setMoveCell({ moveCell: { x: -99999, y: 0, tabStoping: false } });
        }

        if (e.key === 'End') {
            setMoveCell({ moveCell: { x: 99999, y: 0, tabStoping: false } });
        }
    }

    const handleRemoveRule = row => {
        handleSelectAccount(null, row, true);
    }

    const sortGrid = (newSortColumn) => {
        let key = currentCell.key;
        if (!key)
            key = getKeyOfRow(rows[currentCell.key || 0]);

        const newSortOrder = (newSortColumn === sortColumn) ? !sortOrder : true;//todo rename
        let updatedRows;

        if (newSortColumn === 'date') {
            updatedRows = _.orderBy(rows, [row => new moment(row.TransactionDate, 'DD MMM YY')], [(newSortOrder) ? 'asc' : 'desc'])
        } else if (newSortColumn === 'Money out') {
            updatedRows = rows.filter(row => row.Amount <= 0).sort((rowOne, rowTwo) => {
                return (newSortOrder) ? rowTwo.Amount - rowOne.Amount : rowOne.Amount - rowTwo.Amount;
            })
                .concat(
                    rows.filter(row => row.Amount > 0).sort((rowOne, rowTwo) => {
                        return (newSortOrder) ? rowOne.Amount - rowTwo.Amount : rowTwo.Amount - rowOne.Amount;
                    }));
        } else if (newSortColumn === 'Money in') {
            updatedRows = rows.filter(row => row.Amount >= 0).sort((rowOne, rowTwo) => {
                return (newSortOrder) ? rowOne.Amount - rowTwo.Amount : rowTwo.Amount - rowOne.Amount;
            })
                .concat(
                    rows.filter(row => row.Amount < 0).sort((rowOne, rowTwo) => {
                        return (newSortOrder) ? rowTwo.Amount - rowOne.Amount : rowOne.Amount - rowTwo.Amount;
                    }));
        } else {
            updatedRows = _.orderBy(rows, [newSortColumn], [(newSortOrder) ? 'asc' : 'desc']);
        }
        sortRows(updatedRows);
        const newX = findRowX(updatedRows, key);
        handleSorting({
            sortOrder: newSortOrder,
            sortColumn: newSortColumn,
            x: newX,
            y: currentCell.y || 0,
            key: key
        });
        currentCell = { ...currentCell, x: newX, y: currentCell.y };
    }

    // const focusedCellChange = focusedCellDetails => {
    //     setFocusedCell(focusedCellDetails);
    //     currentCell = focusedCellDetails;
    // }

    const getKeyOfRow = row => row ? row.BankDataGUID : undefined

    if (!rows || !transactionCodes || isLoadingTransactions) {
        return <div style={{ height: '96%', display: 'flex' }}><Spinner apiError={apiError} /></div>
    }

    return (columns ? <div id="DataTable"><DataTable columns={columns}
        rows={rows}
        // noLazy
        // placeholderOnScroll
        getRowKey={getKeyOfRow}
        columnWidthValues={columnWidthValues}
        columnMinWidthValues={columnMinWidthValues}
        columnMaxWidthValues={columnMaxWidthValues}
        onColumnResize={saveColumnWidth}
        moveCell={moveCell}
        selectCell={selectCell}
        focusedCellChange={focusedCellChange}
        rowHeight={22}
        onLeaveRow={leaveRow}
        version={version}
        rowsVersion={props.rowsVersion}
        contextMenuId="TransactionContextMenu"
        disabledCellChecker={disabledCellChecker} /></div> : '')
}

export default TransactionDataTable;


// WEBPACK FOOTER //
// ./src/components/TransactionList/TransactionDataTable.js